import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
import QrCode from "@xt/QrCode";
import styles from "./index.module.scss";
import store from "store";
import commonRules from "components/Pages/User/common/rules";
import { useRouter } from "next/router";
import { Tooltip, message, Form, Input } from "antd";
import Dynamic, { DynamicProps, type ExposeDynamicProps } from "components/App/Dynamic/index";
import storeDark from "assets/images/common/store_dark.svg";
import storePre from "assets/images/common/store.svg";
import unionDark from "assets/images/common/Union_dark.svg";
import union from "assets/images/common/Union.svg";
import copySvg from "assets/images/common/Copy.svg";
import handMould from "assets/images/common/handmould.svg";
import correct from "assets/images/common/correct.png";
import error from "assets/images/common/error.png";

import high from "assets/images/common/High.png";
import highSvg from "assets/images/common/High.svg";
import medium from "assets/images/common/Medium.png";
import mediumSvg from "assets/images/common/Medium.svg";
import low from "assets/images/common/Low.png";
import lowSvg from "assets/images/common/Low.svg";

import { getOrigin, getZendeskHcLocale } from "utils/method";
import { openLivehelp100Support } from "@/utils/livehelp100";
import copy from "clipboard-copy";
import {
  get_faResult,
  get_getFaCheckItem,
  get_userGetGoogleSecret,
  post_bindGoogleAuth,
  post_subBindGoogleAuth,
  post_subUnBindGoogleAuth,
  post_unBindGoogleAuth,
} from "api/uaapi/user";
import useNoEmailChange from "components/App/Dynamic/useNoEmailChange";
import useNextTick from "hooks/useNextTick";
import NoEmail from "components/Xt/NoEmail";
import XtSvg from "components/Xt/Svg";
import { delete_unBindNewGoogleAuth, get_googleSecret, post_bindNewGoogleAuth, put_faVerify } from "@/api/uaapi/account";
import { FaCheckProps, FaSceneDictEnum } from "@/store/user";
import useAsyncEffect from "@/hooks/useAsyncEffect";
import { FaItemProps } from "@/components/App/SafeVerify";

interface GoogleAuthenticatorProps extends BaseCompProps {
  attr?: any;
}
const { useTranslation } = Hooks;
let faResultId = "";
let faResultId1 = "";
const GoogleAuthenticator: React.FC<GoogleAuthenticatorProps> = ({ className }) => {
  const [formIns] = Form.useForm();
  const formRef = useRef();
  const router = useRouter();
  const googleHelpArticleHref = useMemo(() => {
    const hc = getZendeskHcLocale(router.locale);
    return `https://spikex.zendesk.com/hc/${hc}/articles/900000468766`;
  }, [router.locale]);
  const t = useTranslation();
  const { isDark } = store.app;
  const { userInfo, isSubAcc, faCheckData, setFaCheckDataItem, emailAuth, mobileAuth, googleAuth, getVerifyItems, getUserInfo } = store.user;
  const nextTick = useNextTick();
  const appCodeDynamicRef = useRef({} as ExposeDynamicProps);
  const [faItems, setFaItems] = useState<FaItemProps[]>([]);
  const googleList = useMemo(() => {
    const arr = [
      {
        id: 1,
        text: t("google.app"),
      },
      {
        id: 2,
        text: t("google.code"),
      },
      {
        id: 3,
        text: t("google.cloud"),
      },
      {
        id: 4,
        text: t("google.Authenticate"),
      },
      {
        id: 5,
        text: t("google.finish"),
      },
    ];
    if (googleAuth) {
      arr[0].text = t("google.relieve");
      arr[1].text = t("google.newcode");
      arr[2].text = t("google.newcloud");
      arr[3].text = t("google.start");
    }
    return arr;
  }, [googleAuth]);
  const [step, setStep] = useState(1);
  const initForm: ObjAny = {
    email: "",
    emailCode: "",
    mobile: "",
    mobileCode: "",
    subCode: "",
    googleCode: "",
  };
  const [formData, setFormData] = useState({ ...initForm });

  const next = (step) => {
    setStep(step);
  };

  const [secret, setSecret] = useState("");
  const [xtDomain, setXtDomain] = useState("xt.com");
  const [emailFa, setEmailFa] = useState(false);
  const [mobileFa, setMobileFa] = useState(false);
  const [googleFa, setGoogleFa] = useState(false);
  useEffect(() => {
    setXtDomain(getOrigin(undefined, "1"));
    getGoogleSecret();
    getFaCheckItem();
  }, []);

  const getUserInfoData = async () => await getUserInfo();

  const faBizType = useMemo(() => {
    // 默认是主账户
    let faBizType = 1;
    if (googleAuth) {
      faBizType = 2;
    }
    // 子账户要重置
    if (isSubAcc) {
      faBizType = googleAuth ? 65 : 64;
    }
    return faBizType;
  }, [googleAuth, isSubAcc]);
  useEffect(() => {
    updateVerifyItems();
  }, [faBizType]);

  // 重新获取需要的绑定项
  const updateVerifyItems = async () => {
    const res = await get_getFaCheckItem({
      params: {
        faBizType,
      },
    });
    faResultId = res.faCheckId;
    setFaItems(res.faItems);
    const emailFa = res.faItems?.some((faItem) => faItem.validateItemType == 0);
    const mobileFa = res.faItems?.some((faItem) => faItem.validateItemType == 1);
    const googleFa = res.faItems?.some((faItem) => faItem.validateItemType == 2);
    setEmailFa(emailFa);
    setMobileFa(mobileFa);
    setGoogleFa(googleFa);

    setFaCheckDataItem({
      faCheckId: res.faCheckId,
      validNumber: res.validNumber || 0,
      faItems: res.faItems,
    });
  };
  const emailItem = useMemo(() => {
    return (faItems.length && faItems.find((_) => _.validateItemType == 0)) || ({} as FaItemProps);
  }, [faItems]);
  const mobileItem = useMemo(() => {
    return (faItems.length && faItems.find((_) => _.validateItemType == 1)) || ({} as FaItemProps);
  }, [faItems]);

  const getFaCheckItem = async () => {
    const data = await getUserInfoData();

    try {
      const newFormData = { ...formData };
      if (data) {
        newFormData.email = data?.email;
        newFormData.mobile = data?.mobile;
      }

      if (isSubAcc && (faBizType == 65 || faBizType == 64)) {
        newFormData.subCode = "";
      }
      if (faBizType == 1) {
        newFormData.googleCode = "";
      }
      if (emailFa) {
        newFormData.emailCode = "";
      }
      if (mobileFa) {
        newFormData.mobileCode = "";
      }
      if (googleFa) {
        newFormData.googleCode = "";
      }
      setFormData(newFormData);
    } catch (error) {
      console.log(error);
    }
  };

  const imgUrl = useMemo(() => {
    if (secret && userInfo) {
      return `otpauth://totp/${xtDomain}:${userInfo.userName}?secret=${secret}&issuer=${xtDomain}`;
    }
  }, [secret, xtDomain, userInfo]);

  const copyTxt = () => {
    copy(secret)
      .then(() => {
        message.success(t("account.copy"));
      })
      .catch(() => {
        message.error(t("app.copyErr"));
      });
  };

  const getGoogleSecret = async () => {
    try {
      const res = await get_userGetGoogleSecret();
      setSecret(res.googleSecretKey);
    } catch (error) {
      console.log(error);
    }
  };
  type FormDataType = typeof initForm & ObjAny;
  const valuesChange = (changedValues: FormDataType, allValues: FormDataType) => {
    const data = { ...formData, ...changedValues };
    setFormData(data);
  };
  const { noEmailChange, noEmailVisible } = useNoEmailChange();
  const [showModal, setShowModal] = useState(false);
  const [mobileMsgType, setMobileMsgType] = useState(0);
  const [statusState, setStatusState] = useState(true);

  const backUrl = useMemo(() => window.location.origin + window.location.pathname, []);

  const [otherForm, setOtherForm] = useState<ObjAny>({
    googleCode: "",
  });

  const submitForm = async () => {
    if (!userInfo) return;
    const params = {
      emailCode: formData.emailCode,
      mobileCode: formData.mobileCode,
      googleCode: formData.googleCode,
      faBizType,
      faCheckId: faResultId,
    };

    const res = await get_faResult({
      isResFull: true,
      params,
      errorPop: true,
    });
    if (res && res.code === 200) {
      faResultId1 = res.data.faResultId;
    }

    const commonParams = { faResultId: faResultId1, googleCode: formData.googleCode, googleSecret: secret };
    // 主账户直接绑定-第4步
    if (faBizType == 1) {
      await post_bindGoogleAuth({
        isResFull: true,
        errorPop: true,
        data: {
          ...commonParams,
        },
      }).then(async () => {
        await getUserInfo();
        next(5);
        setStatusState(true);
      });
    }
    // 主账户先解绑-第1步
    if (faBizType == 2) {
      const bind = await post_unBindGoogleAuth({
        isResFull: true,
        errorPop: true,
        data: {
          faResultId: faResultId1,
        },
      });
      if (bind && bind.code === 200) {
        formIns.setFieldsValue({
          ...formData,
          emailCode: "",
          mobileCode: "",
          subCode: "",
          googleCode: "",
        });
        await getUserInfo();
        await updateVerifyItems();
        next(2);
      }
    }

    // 子账户直接绑定-第4步
    if (faBizType == 64) {
      const bind = await post_subBindGoogleAuth({
        isResFull: true,
        errorPop: true,
        data: {
          ...commonParams,
          accountId: userInfo.accountId,
          googleCode: formData.subCode,
        },
      });
      if (bind && bind.code === 200) {
        await getUserInfo();
        next(5);
        setStatusState(true);
      }
    }
    // 子账户先解绑-第1步
    if (faBizType == 65) {
      const bind = await post_subUnBindGoogleAuth({
        isResFull: true,
        errorPop: true,
        data: {
          ...commonParams,
          accountId: userInfo.accountId,
          googleCode: formData.subCode,
        },
      });
      if (bind && bind.code === 200) {
        await getUserInfo();
        // await updateVerifyItems();
        formIns.setFieldsValue({
          ...initForm,
        });
        next(2);
      }
    }
  };

  useEffect(() => {
    console.log(formData, "formData1111111");
  }, [formData]);

  type OtherFormDataType = typeof initForm & ObjAny;
  const valuesOtherChange = (changedValues: OtherFormDataType, OtherFormDataType: FormDataType) => {
    const data = { ...formData, ...changedValues };
    setOtherForm(data);
  };

  const disabledForm = useMemo(() => {
    const mapCode = {
      emailCode: emailFa,
      mobileCode: mobileFa,
      googleCode: !isSubAcc || (isSubAcc && googleFa),
    };
    return Object.keys(formData)
      .filter((k) => !!mapCode[k])
      .some((k1) => formData[k1] == "");
  }, [formData, emailFa, mobileFa, googleFa, isSubAcc]);

  const submitOtherForm = async () => {
    if (!userInfo) return;
    try {
      // 主账户解绑之后的绑定-第4步
      let res;
      // 主账户解绑之后的绑定-第4步
      const commonParams = { faResultId: faResultId1, googleCode: otherForm.googleCode, googleSecret: secret };
      if (!isSubAcc) {
        res = await post_bindGoogleAuth({
          isResFull: true,
          errorPop: true,
          data: {
            ...commonParams,
          },
        });
      } else {
        // 子账户解绑之后的绑定-第4步
        res = await post_subBindGoogleAuth({
          isResFull: true,
          errorPop: true,
          data: {
            ...commonParams,
            accountId: userInfo.accountId,
          },
        });
      }
      if (res && res.code === 200) {
        next(5);
        setStatusState(true);
      }
    } catch (error) {}
  };
  const goBack = () => {
    router.push("/accounts/user/security-center");
  };

  return (
    <div className={cx(styles.google, isDark && styles.google_dark, className)}>
      {/* 顶栏由 pages/accounts/user 的 backHeader 统一提供 */}
      <div className={styles.content}>
        <div className={styles.left}>
          {googleList.map((item, index) => (
            <React.Fragment key={item.id}>
              {index > 0 && (
                <div
                  className={cx(styles.connector, step >= index + 1 ? styles.connectorActive : "")}
                  aria-hidden
                />
              )}
              <div
                className={cx(styles.item, item.id <= step ? styles["active"] : styles.itemInactive)}
                style={{
                  backgroundImage: `url(${require(`@/assets/images/account/six${item.id <= step ? "" : "-active"}.svg`).default})`,
                }}
              >
                {item.id}
              </div>
              <p className={styles.stepLabel}>{item.text}</p>
            </React.Fragment>
          ))}
        </div>
        <div className={styles.right}>
          <div className={styles.rightContent}>
            {/* 移动端：仅显示当前步骤名称，减少垂直占用 */}
            <div className={styles.stepCaption} aria-hidden>
              {googleList[step - 1]?.text}
            </div>
            {/* 绑定谷歌浏览器 */}
            {!googleAuth && step == 1 && (
              <>
                <div className={styles["title"]}>{t("google.Authenticate1")}</div>
                <div className={styles["text"]}>{t("google.down")}</div>
                <div className={cx(styles.tip, styles.tip2)}>
                  <a
                    href="https://apps.apple.com/us/app/google-authenticator/id388497605"
                    target="_blank"
                    className={cx(styles.apple, styles.tip_item)}
                    rel="noreferrer"
                  >
                    <div>
                      <img src={isDark ? storeDark : storePre} alt="store" />
                    </div>
                    <div className={cx(styles.tip_text)}>{t("cmpt.download")}</div>
                    <div className={cx(styles.tip_text1)}>{t("google.store")}</div>
                  </a>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"
                    target="_blank"
                    className={cx(styles.play, styles.tip_item)}
                    rel="noreferrer"
                  >
                    <div>
                      <img src={isDark ? unionDark : union} alt="store" />
                    </div>
                    <div className={cx(styles.tip_text)}>{t("cmpt.download")}</div>
                    <div className={cx(styles.tip_text1)}>{t("google.play")}</div>
                  </a>
                </div>
                <a
                  href={googleHelpArticleHref}
                  target="_blank"
                  className={cx(styles.right1_set)}
                  rel="noreferrer"
                >
                  {t("google.set")}
                </a>
                <div className={cx(styles.opera)}>
                  <div
                    onClick={() => {
                      next(2);
                    }}
                    className={cx(styles.next)}
                  >
                    {t("account.next")}
                  </div>
                </div>
              </>
            )}

            {/* 更改谷歌浏览器 */}
            {googleAuth && step == 1 && (
              <>
                <div className={styles.title}>{t("google.changeGoogle")}</div>
                <div className={styles.text_mf}>{t("google.relieveWorn")}</div>
                <div className={styles["tan"]}>
                  <XtSvg src={require("@/assets/icon-svg/app/tan.svg")} />
                  <div className={styles["text_tan"]}>{t("account.safeFund")}</div>
                </div>
                <div className={cx(styles.tip, styles.tipFa)}>
                  <Form name="safeVerifyForm" initialValues={formData} form={formIns} onValuesChange={valuesChange} layout="vertical">
                    {isSubAcc && (
                      <Form.Item name="subCode" label={t("account.AuthenticationCode")}>
                        <Input allowClear className={styles["common_form_input"]} autoComplete={"off"} />
                      </Form.Item>
                    )}

                    {emailFa && (
                      <Form.Item
                        name="emailCode"
                        label={t("google.gmail", { email: formData.email && formData.email.replace(/(\w{2}).*(\w{1})@(.*)/, "$1***@$3") })}
                        rules={commonRules.emailCode}
                      >
                        <Input
                          maxLength={6}
                          allowClear
                          className={styles["common_form_input"]}
                          autoComplete="off"
                          suffix={
                            <div className={styles["forget_password"]}>
                              <Dynamic
                                faCheckId={faCheckData.faCheckId}
                                FaValidTypeDict={"EMAIL"}
                                codeType={emailItem.msgType}
                                receiveAddress={formData.email}
                                msgType={2}
                                noEmailChange={noEmailChange}
                              />
                            </div>
                          }
                        />
                      </Form.Item>
                    )}
                    {formData.email && noEmailVisible && (
                      <div className={cx(styles["text2"], styles["no_email"])} onClick={() => setShowModal(true)}>
                        {t("google.noEmail")}
                      </div>
                    )}

                    {mobileFa && (
                      <Form.Item
                        name="mobileCode"
                        rules={commonRules.mobileCode}
                        label={t("google.mobile", {
                          mobile:
                            formData.mobile.length > 7
                              ? formData.mobile.replace(/(\d{3})\d*(\d{4})/, "$1***$2")
                              : formData.mobile.replace(/(\d{2})\d*(\d{2})/, "$1***$2"),
                        })}
                      >
                        <Input
                          maxLength={6}
                          allowClear
                          className={styles["common_form_input"]}
                          autoComplete="off"
                          suffix={
                            <div className={styles["forget_password"]}>
                              <Dynamic
                                ref={appCodeDynamicRef}
                                FaValidTypeDict={"MOBILE"}
                                faCheckId={faCheckData.faCheckId}
                                codeType={mobileItem.msgType}
                                msgType={mobileMsgType}
                                receiveAddress={formData.mobile}
                                onClick={() => {
                                  setMobileMsgType(0);
                                }}
                              />
                            </div>
                          }
                        />
                      </Form.Item>
                    )}
                    {/* 语音验证码功能已注释 */}
                    {/* {mobileFa && (
                      <div className={cx(styles["voice"], styles.mt12)}>
                        <span onClick={() => { setMobileMsgType(1); nextTick(() => appCodeDynamicRef.current.handleClick(true)); }}>
                          {t("2fa.voiceCode")}
                        </span>
                      </div>
                    )} */}
                    {googleFa && (
                      <Form.Item
                        name="googleCode"
                        label={t("account.AuthenticationCode") + (isSubAcc ? `(${t("sub.mainAccount")})` : "")}
                        rules={commonRules.googleCode}
                      >
                        <Input maxLength={6} allowClear className={styles["common_form_input"]} autoComplete="off" />
                      </Form.Item>
                    )}
                    {faCheckData.faItems.length && !isSubAcc && (
                      <>
                        {/* 原：Link → /accounts/user/reset-verification */}
                        {/* <Link href={{ pathname: "/accounts/user/reset-verification", search: `faCheckId=${faCheckData.faCheckId}&backUrl=${backUrl}` }}>
                          <div className={cx(styles["text2"], styles.mt12)}>{t("google.security")}</div>
                        </Link> */}
                        <div
                          className={cx(styles["text2"], styles.mt12)}
                          role="button"
                          tabIndex={0}
                          onClick={() => openLivehelp100Support()}
                          onKeyDown={(e) => e.key === "Enter" && openLivehelp100Support()}
                        >
                          {t("google.security")}
                        </div>
                      </>
                    )}
                  </Form>
                  <div className={styles.opera}>
                    <div onClick={submitForm} className={cx(styles.next, disabledForm ? styles.disabledBtn : "")}>
                      {t("account.next")}
                    </div>
                  </div>
                </div>
              </>
            )}
            {/* 第2步  */}
            {step == 2 && (
              <>
                <div className={styles.title}>{googleAuth ? t("google.changeGoogle") : t("google.Authenticate1")}</div>
                <div className={styles.text}>{t("google.qr")}</div>
                <div className={cx(styles.tip, styles.tip1)}>
                  <div className={cx(styles.tip_qr)}>{userInfo && secret && <QrCode content={imgUrl} size={150} isShowLogo={false} />}</div>
                </div>
                <div className={styles.secret}>
                  <input id={"secret"} className={styles.secretInput} type="text" readOnly={true} value={secret} />
                  <Tooltip placement="top" title={t("google.copy")}>
                    <img onClick={copyTxt} className={styles.copy} src={copySvg} alt="copy" />
                  </Tooltip>
                </div>
                <div className={styles.opera}>
                  {!googleAuth && (
                    <div
                      onClick={() => {
                        next(1);
                      }}
                      className={styles.pre}
                    >
                      {t("google.pre")}
                    </div>
                  )}

                  <div
                    onClick={() => {
                      next(3);
                    }}
                    className={styles.next}
                  >
                    {t("account.next")}
                  </div>
                </div>
              </>
            )}
            {/* 第三步 */}
            {step == 3 && (
              <>
                <div className={styles.title}>{t("google.Authenticate1")}</div>
                <div className={styles.text}>
                  {t("google.suggest")}
                  <span className={styles.red_tip}>{t("google.handmould")}</span>
                  {t("google.save")}
                </div>
                <div className={cx(styles.tip, styles.tip1)}>
                  <img className={cx(styles.handmould)} src={handMould} alt="handMould" />
                </div>
                <div className={styles.secret}>
                  <input id={"secret"} className={styles.secretInput} type="text" readOnly={true} value={secret} />
                  <Tooltip placement="top" title={t("google.copy")}>
                    <img onClick={copyTxt} className={styles.copy} src={copySvg} alt="copy" />
                  </Tooltip>
                </div>
                <div className={styles.text1}>{t("google.saveTip1")}</div>
                <div className={styles.opera}>
                  <div
                    onClick={() => {
                      next(2);
                    }}
                    className={styles.pre}
                  >
                    {t("google.pre")}
                  </div>
                  <div
                    onClick={() => {
                      next(4);
                    }}
                    className={styles.next}
                  >
                    {t("account.next")}
                  </div>
                </div>
              </>
            )}
            {/* 第四步 绑定谷歌验证器 4 */}
            {step == 4 && !googleAuth && (
              <>
                <div className={styles.title}>{t("google.Authenticate1")}</div>
                <div className={styles.text}>{t("google.verify")}</div>
                <div className={cx(styles.tip, styles.tipFa)}>
                  <Form name="safeVerifyForm1" initialValues={formData} form={formIns} onValuesChange={valuesChange} layout="vertical">
                    {isSubAcc && (
                      <Form.Item name="subCode" label={t("account.AuthenticationCode")}>
                        <Input allowClear maxLength={6} className={styles["common_form_input"]} autoComplete={"off"} />
                      </Form.Item>
                    )}
                    {emailFa && (
                      <Form.Item
                        name="emailCode"
                        label={t("google.gmail", { email: formData.email && formData.email.replace(/(\w{2}).*(\w{1})@(.*)/, "$1***@$3") })}
                        rules={commonRules.emailCode}
                      >
                        <Input
                          maxLength={6}
                          allowClear
                          className={styles["common_form_input"]}
                          autoComplete="off"
                          suffix={
                            <div className={styles["forget_password"]}>
                              <Dynamic
                                faCheckId={faCheckData.faCheckId}
                                FaValidTypeDict={"EMAIL"}
                                codeType={emailItem.msgType}
                                receiveAddress={formData.email}
                                msgType={2}
                                noEmailChange={noEmailChange}
                              />
                            </div>
                          }
                        />
                      </Form.Item>
                    )}
                    {formData.email && noEmailVisible && (
                      <div className={cx(styles["text2"], styles["no_email"])} onClick={() => setShowModal(true)}>
                        {t("google.noEmail")}
                      </div>
                    )}
                    {mobileFa && (
                      <Form.Item
                        name="mobileCode"
                        rules={commonRules.mobileCode}
                        label={t("google.mobile", {
                          mobile:
                            formData.mobile &&
                            (formData.mobile.length > 7
                              ? formData.mobile.replace(/(\d{3})\d*(\d{4})/, "$1***$2")
                              : formData.mobile.replace(/(\d{2})\d*(\d{2})/, "$1***$2")),
                        })}
                      >
                        <Input
                          maxLength={6}
                          allowClear
                          className={styles["common_form_input"]}
                          autoComplete="off"
                          suffix={
                            <div className={styles["forget_password"]}>
                              <Dynamic
                                ref={appCodeDynamicRef}
                                FaValidTypeDict={"MOBILE"}
                                faCheckId={faCheckData.faCheckId}
                                codeType={mobileItem.msgType}
                                msgType={mobileMsgType}
                                receiveAddress={formData.mobile}
                                onClick={() => {
                                  setMobileMsgType(0);
                                }}
                              />
                            </div>
                          }
                        />
                      </Form.Item>
                    )}
                    {/* 语音验证码功能已注释 */}
                    {/* {mobileFa && (
                      <div className={cx(styles["voice"], styles.mt12)}>
                        <span onClick={() => { setMobileMsgType(1); nextTick(() => appCodeDynamicRef.current.handleClick(true)); }}>
                          {t("2fa.voiceCode")}
                        </span>
                      </div>
                    )} */}
                    {isSubAcc} {googleFa}
                    {(!isSubAcc || (isSubAcc && googleFa)) && (
                      <Form.Item
                        name="googleCode"
                        label={t("account.AuthenticationCode") + (isSubAcc ? `(${t("sub.mainAccount")})` : "")}
                        rules={commonRules.googleCode}
                      >
                        <Input maxLength={6} allowClear className={styles["common_form_input"]} autoComplete="off" />
                      </Form.Item>
                    )}
                    {faCheckData.faItems.length && !isSubAcc && (
                      <>
                        {/* 原：Link → /accounts/user/reset-verification */}
                        {/* <Link href={{ pathname: "/accounts/user/reset-verification", search: `faCheckId=${faCheckData.faCheckId}&backUrl=${backUrl}` }}>
                          <div className={cx(styles["text2"], styles.mt12)}>{t("google.security")}</div>
                        </Link> */}
                        <div
                          className={cx(styles["text2"], styles.mt12)}
                          role="button"
                          tabIndex={0}
                          onClick={() => openLivehelp100Support()}
                          onKeyDown={(e) => e.key === "Enter" && openLivehelp100Support()}
                        >
                          {t("google.security")}
                        </div>
                      </>
                    )}
                  </Form>
                  <div className={styles.opera}>
                    <div
                      onClick={() => {
                        next(3);
                      }}
                      className={styles.pre}
                    >
                      {t("google.pre")}
                    </div>
                    <div onClick={submitForm} className={cx(styles.next, disabledForm ? styles.disabledBtn : "")}>
                      {t("account.next")}
                    </div>
                  </div>
                </div>
              </>
            )}
            {/* 第四步 更改谷歌验证器 4 */}
            {step == 4 && googleAuth && (
              <>
                <div className={styles.title}>{t("google.changeGoogle")}</div>
                <div className={styles.text}>{t("google.verify")}</div>
                <div className={cx(styles.tip, styles.tipFa)}>
                  <Form name="safeVerifyForm2" initialValues={otherForm} form={formIns} onValuesChange={valuesOtherChange} layout="vertical">
                    <Form.Item name="googleCode" label={t("account.AuthenticationCode")} rules={commonRules.googleCode}>
                      <Input maxLength={6} allowClear className={styles["common_form_input"]} autoComplete="off" />
                    </Form.Item>
                  </Form>
                  <div className={styles.opera}>
                    <div
                      onClick={() => {
                        next(3);
                      }}
                      className={styles.pre}
                    >
                      {t("google.pre")}
                    </div>
                    <div onClick={submitOtherForm} className={cx(styles.next, !otherForm.googleCode ? styles.disabledBtn : "")}>
                      {t("account.next")}
                    </div>
                  </div>
                </div>
              </>
            )}

            {/* 绑定谷歌验证器 5 */}
            {step == 5 && !googleAuth && (
              <>
                <div className={styles.title}>{t("google.Authenticate1")}</div>
                <div className="save_img">
                  <img src={statusState ? correct : error} alt="correct" />
                </div>
                {statusState ? <div className={styles.title1}>{t("google.success")}</div> : <div className={styles.title1}>{t("google.error")}</div>}

                {/* <!-- 安全等级 --> */}
                {statusState && !isSubAcc && (
                  <div className={styles.level}>
                    <div className={styles.level_text}>{t("google.level")}</div>
                    {!isDark ? (
                      <div className={styles.level_img}>
                        {<img src={emailAuth && mobileAuth ? highSvg : (emailAuth && !mobileAuth) || (mobileAuth && !emailAuth) ? mediumSvg : lowSvg} alt="" />}
                      </div>
                    ) : (
                      <div className={styles.level_img}>
                        {<img src={emailAuth && mobileAuth ? high : (emailAuth && !mobileAuth) || (mobileAuth && !emailAuth) ? medium : low} alt="" />}
                      </div>
                    )}
                    {emailAuth && mobileAuth ? (
                      <div className={styles.level_level}>{t("account.High")}</div>
                    ) : (emailAuth && !mobileAuth) || (mobileAuth && !emailAuth) ? (
                      <div className={styles.level_level}>{t("account.Medium")}</div>
                    ) : (
                      <div className={styles.level_level}>{t("account.Low")}</div>
                    )}
                  </div>
                )}

                {statusState && isSubAcc && (
                  <div className={styles.level}>
                    <div className={styles.level_text}>{t("google.level")}</div>

                    {!isDark ? (
                      <div className={styles.level_img}>{<img src={googleAuth ? highSvg : lowSvg} alt="" />}</div>
                    ) : (
                      <div className={styles.level_img}>{<img src={googleAuth ? high : low} alt="" />}</div>
                    )}
                    {googleAuth ? <div className={styles.level_level}>{t("account.High")}</div> : <div className={styles.level_level}>{t("account.Low")}</div>}
                  </div>
                )}

                {/* <!-- 成功按钮 --> */}
                {statusState && !isSubAcc && (
                  <div className={cx(styles.opera, styles.google_opera)}>
                    {userInfo && (!userInfo.email || !userInfo.mobile) && (
                      <a href="javascript:void" onClick={goBack}>
                        <div className={styles.pre}>{t("google.backSafe")}</div>
                      </a>
                    )}
                    {userInfo && !userInfo.email && (
                      <a href={`/${router.locale}/accounts/user/email`}>
                        <div className={styles.next}>{t("google.bindEmail")}</div>
                      </a>
                    )}
                    {userInfo && userInfo.email && !userInfo.mobile && !isSubAcc && (
                      <a href={`/${router.locale}/accounts/user/mobile`}>
                        <div className={styles.next}>{t("google.bindMobile")}</div>
                      </a>
                    )}
                    {userInfo && userInfo.email && userInfo.mobile && (
                      <a href="javascript:void" onClick={goBack}>
                        <div className={styles.next}>{t("google.backSafe")}</div>
                      </a>
                    )}
                  </div>
                )}

                {statusState && (
                  <div className={cx(styles.opera, styles.google_opera)}>
                    <a href="javascript:void" onClick={goBack}>
                      <div className={styles.next}>{t("google.backSafe")}</div>
                    </a>
                  </div>
                )}
              </>
            )}
            {/* 更改谷歌验证器 5 */}
            {step == 5 && googleAuth && (
              <>
                <div className={styles.title}>{t("google.changeGoogle")}</div>
                <div className={styles.text}>{t("google.verify")}</div>
                <div className={styles.save_img}>
                  <img src={statusState ? correct : error} alt="" />
                </div>
                <div className={styles.title1}>{statusState ? t("google.success") : t("google.error")}</div>
                {statusState && (
                  <div className={styles.opera}>
                    <a href="javascript:void" onClick={goBack}>
                      <div className={styles.next}>{t("google.backSafe")}</div>
                    </a>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      <NoEmail open={showModal} changeOpen={() => setShowModal(false)} email={formData.email} />
    </div>
  );
};
export default observer(GoogleAuthenticator);
